<app-az-header></app-az-header>
<app-az-menu></app-az-menu>

<div class="dashboard-container">
  <!-- Year Dropdown -->
  <div class="event-year-dropdown">
    <label for="yearSelect">Select Year:</label>
    <select
      id="yearSelect"
      [(ngModel)]="selectedYear"
      (change)="getEventData(selectedYear)"
    >
      <option *ngFor="let year of years" [value]="year">{{ year }}</option>
    </select>
  </div>

  <!-- Statistics Cards -->
  <div class="stats-grid">
    <div class="stat-card">
      <h3>Total Attendees</h3>
      <p>{{ totalAttendees }}</p>
    </div>
    <div class="stat-card">
      <h3>Communities</h3>
      <p>{{ communities }}</p>
    </div>
    <div class="stat-card">
      <h3>Speakers</h3>
      <p>{{ speakers }}</p>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
